export default __webpack_public_path__ + "static/media/workspaces-logo-colour.f954a512.svg";